import { PropsWithChildren, ReactNode } from 'react';

import { NavLink, useLocation } from 'react-router-dom';
import type { Location } from 'react-router-dom';

import { Col, Container, Row } from 'react-bootstrap';

import { translate } from '@/domain/utils/translate';

import IconList from '@/ui/components/IconList';
import { getRoutesDirections } from '@/data/libraries/RoutesTranslated';

interface PropsClientList {
  /** Clase para mostrar y ocultar barra al final del listado */
  classBar?: string;
  /** Evento que maneja el modal */
  handleModal?: (params: any) => ReactNode | void;
}

/** Componente Nav Usuario Logueado
 * @component
 */
const ClientListUserInformation = ({ classBar = '', handleModal }: PropsWithChildren<PropsClientList>): JSX.Element => {
  /**  Hook para trabajar con document location  */
  const location: Location = useLocation();

  /** Rutas URLs */
  const routesDirections = getRoutesDirections();

  return (
    <Container id='client-list' fluid className='p-0'>
      <Row className='g-0'>
        <Col xs={12}>
          <ul className='list-unstyled svg-secondary-1 d-flex flex-column'>
            <NavLink to={routesDirections.USER_INFO_ROUTE} state={{ originURL: location.pathname }}>
              <IconList
                iconName='ico-info'
                classMain='p-2 my-1 btn-list-link-icon-light-small '
                classTitle='p-regular'
                title={translate("session.account_info")}
                onClick={handleModal}
                classIcon='pe-2'
              />
            </NavLink>
            <NavLink to={routesDirections.CHANGE_PASSWORD_ROUTE} state={{ originURL: location.pathname }}>
              <IconList
                iconName='ico-password'
                classMain='p-2 my-1 btn-list-link-icon-light-small'
                classTitle='p-regular'
                title={translate("session.password_label")}
                onClick={handleModal}
                classIcon='pe-2'
              />
            </NavLink>

            <li className={`mx-2 my-4 bg-secondary-5 mh-2-px ${classBar}`}></li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
};

export default ClientListUserInformation;
